export enum FilterForReport {
  Date = 'dateFilter',
  Vehicle = 'vehicleFilter',
  Demographic = 'demographicFilter',
  Location = 'locationFilter',
  Personal = 'personalFilter',
  StopDetails = 'stopDetailsFilter',
  CitationTypes = 'citationTypes',
}

export const FilterGroupTitles: Record<string, string> = {
  [FilterForReport.Date]: 'Time',
  [FilterForReport.Vehicle]: 'Vehicles',
  [FilterForReport.Demographic]: 'Demographics',
  [FilterForReport.Location]: 'Areas',
  [FilterForReport.Personal]: 'Personal',
  [FilterForReport.StopDetails]: 'Stop Details',
  [FilterForReport.CitationTypes]: 'Offence Desc',
};

export const FilterTitles: Record<string, string> = {
  // Date
  fromDate: 'From date',
  toDate: 'To date',
  fromTime: 'From time',
  toTime: 'To time',
  daysOfWeek: 'Days of week',
  months: 'Months',
  dayNight: 'Day / night',
  // Vehicles
  colors: 'Colors',
  makes: 'Makes',
  types: 'Types',
  models: 'Models',
  releaseDateFrom: 'Release date from',
  releaseDateTo: 'Release date to',
  // Demographics
  races: 'Races',
  gender: 'Gender',
  ageGroup: 'Age group',
  // Location
  zipCodes: 'Zip codes',
  cities: 'Cities',
  // Personal
  officerId: 'Officer id',
  officerName: 'Officer name',
  // Reasons for stop
  reasonsForStop: 'Reasons for stop',
  reasonsForSearch: 'Reasons for search',
  contrabandOrEvidence: 'Contraband or evidence',
  resultsOfStop: 'Results of stop',
};

export enum PageType {
  MAP,
  ALL_DATA,
  CITATIONS,
  PERSONS,
  VEHICLES,
  TREEMAP,
}

export const filtersForPageReport: Record<PageType, FilterForReport[]> = {
  [PageType.CITATIONS]: [FilterForReport.Date],
  [PageType.PERSONS]: [FilterForReport.Date, FilterForReport.StopDetails, FilterForReport.Demographic],
  [PageType.VEHICLES]: [FilterForReport.Date, FilterForReport.Vehicle],
  [PageType.TREEMAP]: [
    FilterForReport.Date,
    FilterForReport.CitationTypes,
    FilterForReport.Demographic,
    FilterForReport.Location,
  ],
  [PageType.MAP]: Object.values(FilterForReport),
  [PageType.ALL_DATA]: Object.values(FilterForReport),
};
